import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { db, storage } from "../../firebase";
import Dropzone from "react-dropzone";

const ContentImg = (props) => {
  const authUser = useSelector((state) => state.sessionState.authUser);
  const { page, pageContent, item, itemIndex } = props;
  const [content, setContent] = useState([]);
  const [contentID, setContentID] = useState("");
  const [editing, setEditing] = useState(false);
  const [error, setError] = useState(null);
  const [imageAddStatus, setImageAddStatus] = useState("");
  const [contentAddImgUpload, setContentAddImgUpload] = useState([]);

  useEffect(() => {
    setContent(
      pageContent && pageContent[item] && pageContent[item][itemIndex]
        ? pageContent[item][itemIndex].img
        : pageContent[item].img
        ? pageContent[item].img
        : []
    );
    setContentID(
      pageContent && pageContent[item] && pageContent[item][itemIndex]
        ? pageContent[item][itemIndex].id
        : pageContent[item].img
        ? pageContent[item].id
        : []
    );
  }, [pageContent, item, itemIndex]);

  useEffect(() => {
    return () => {
      contentAddImgUpload.forEach((upload) => {
        upload.cancel();
      });
    };
  }, [contentAddImgUpload]);

  const editToggle = () => {
    setEditing(!editing);
  };

  const updateDB = useCallback(
    (path, content, update) => {
      db.saveContent(page, path, { img: content }).then(() => {
        // setContent(update);
        setImageAddStatus("");
      });
    },
    [page]
  );

  const saveImage = useCallback(
    (contentUpdate, file) => {
      const storageRef = storage.getRef(
        `content/${page}/${item}/${contentID}/${file[0].name}`
      );
      const uploadTask = storage.uploadFiles(storageRef, file[0]);
      setContentAddImgUpload((prevUploads) => [...prevUploads, uploadTask]);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          if (snapshot.bytesTransferred === snapshot.totalBytes) {
            console.log("Save Complete");
          }
        },
        (error) => {
          console.error("Upload error: ", error);
          setError(error);
        },
        () => {
          db.getPostIndex(page, "posts", contentID).then((res) => {
            const postIndex = Object.keys(res.val())[0];
            storage.getDownload(uploadTask.snapshot.ref).then((downloadURL) => {
              contentUpdate.posts[postIndex].img = downloadURL;
              updateDB(`posts/${postIndex}`, downloadURL);
            });
          });
        }
      );
    },
    [item, page, contentID, updateDB]
  );

  const saveContent = useCallback(
    (file) => {
      setError(null);
      setImageAddStatus("uploading");
      db.getPageContent(page).then((siteContent) => {
        const contentUpdate = siteContent.val();
        const contentImage = content ? storage.getRef(content) : null;
        if (contentImage) {
          storage.deleteFile(contentImage).then(() => {
            saveImage(contentUpdate, file);
          });
        } else {
          saveImage(contentUpdate, file);
        }
      });
    },
    [page, content, saveImage]
  );

  return content && authUser ? (
    <div className="content-editor-wrap">
      <span
        className={`content-editor content-img ${editing ? "active" : ""}`}
        onClick={editToggle}
      >
        <img src={content} alt={item} />
        <span className="content-edit">
          <Dropzone
            style={{}}
            multiple={false}
            disabled={imageAddStatus !== ""}
            className="content-edit-img-dropzone files-dropzone"
            activeClassName="active"
            onDrop={(file) => saveContent(file)}
          >
            <div className="content-img-drop files-drop">
              <div className="btn btn-primary" disabled={imageAddStatus !== ""}>
                {imageAddStatus === "uploading" ? (
                  <span className="btn-loading" />
                ) : imageAddStatus === "complete" ? (
                  "upload complete!"
                ) : (
                  "click to upload"
                )}
              </div>
            </div>
          </Dropzone>
          {error && <p className="error">{error}</p>}
        </span>
      </span>
    </div>
  ) : !content && authUser ? (
    <div className="content-editor-wrap content-img">
      <span
        className={`content-editor ${editing ? "active" : ""}`}
        onClick={editToggle}
      >
        <span className="inline-loading" />
        <span className="content-edit">
          <Dropzone
            style={{}}
            multiple={false}
            disabled={imageAddStatus !== ""}
            className="content-edit-img-dropzone files-dropzone"
            activeClassName="active"
            onDrop={(file) => saveContent(file)}
          >
            <div className="content-img-drop files-drop">
              <div className="btn btn-primary" disabled={imageAddStatus !== ""}>
                {imageAddStatus === "uploading" ? (
                  <span className="btn-loading" />
                ) : imageAddStatus === "complete" ? (
                  "upload complete!"
                ) : (
                  "click to upload"
                )}
              </div>
            </div>
          </Dropzone>
          {error && <p className="error">{error}</p>}
        </span>
      </span>
    </div>
  ) : content && !authUser ? (
    <div className="content-img">
      <img src={content} alt={`imagery ${itemIndex}`} />
    </div>
  ) : (
    <span className="inline-loading" />
  );
};

export default ContentImg;
